import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from './Modal';

class ModalToggle extends Component {
  state = {
    show: false,
  };

  open = event => {
    event.preventDefault();
    this.setState({ show: true });
    const { onOpen } = this.props;
    if (onOpen) onOpen(event);
  };

  close = event => {
    this.setState({ show: false });

    const { onClose } = this.props;
    if (onClose) onClose(event);
  };

  render = () => {
    const { children, className, modalProps, renderAs, label, onOpen, onClose, ...rest } = this.props;
    const ToggleElement = renderAs;
    return (
      <div className={className}>
        <ToggleElement onClick={this.open} {...rest}>{label}</ToggleElement>
        <Modal show={this.state.show} onClose={this.close} {...modalProps}>
          {children}
        </Modal>
      </div>
    );
  }
}

ModalToggle.propTypes = {
  renderAs: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  label: PropTypes.node.isRequired,
  modalProps: PropTypes.object,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

ModalToggle.defaultProps = {
  modalProps: null,
  renderAs: 'a',
  onOpen: null,
  onClose: null,
  className: null
};

export { ModalToggle };
